export default "__VITE_ASSET__kIlcREmh__"